import contentRequest from '~/src/api/requests/contentRequest';


/**
 * Получаем пакеты каналов, где есть конкретный телеканал
 *
 * @param {string} id - ID канала
 * @param {number} providerId - город
 * @returns {array} - массив со списком пакетов каналов
 */
export async function getPackagesWithChannel(id, providerId) {
    // Получаем информацию о канале
    const channelInfo = await contentRequest.get(`/v1/channels/channels?providerId=${providerId}`)
        .then(({ data }) => data.items.filter(channel => channel.id === Number.parseInt(id, 10))[0])
        .catch(() => []);

    if (channelInfo && Array.isArray(channelInfo.channelPackageIds) === false) {
        return;
    }

    // Получаем список пакетов
    return contentRequest.get(`/v1/channels/packages?providerId=${providerId}`)
        .then(({ data }) => data.filter(pack => channelInfo.channelPackageIds.includes(pack.id)))
        .catch(() => []);
}
